import React, { memo, PropsWithChildren } from 'react';
import { cn } from 'lib/utils';

interface GridWrapperProps {
  gap?: number;
  columns?: number;
  className?: string;
}

interface Props extends PropsWithChildren, GridWrapperProps {}

function Grid(props: Props) {
  const { gap = 16, columns = 1, children, className } = props;
  const gapClass = gap > 0 ? `gap-${Math.min(gap, 32)}` : 'gap-0';
  const colClass = columns > 1 ? `sm:grid-cols-${Math.min(columns, 12)}` : '';

  return (
    <div className={cn('grid grid-cols-1', colClass, gapClass, className)}>
      {children}
    </div>
  );
}

export default memo(Grid);
